import { rmaService } from '../../services/RmaService';
const state = {
    requests: [],
    currentRequest: null,
    stats: null,
    loading: false,
    error: null,
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
        pages: 0,
    },
};
const mutations = {
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    SET_REQUESTS(state, { requests, pagination }) {
        state.requests = requests;
        state.pagination = pagination;
    },
    SET_CURRENT_REQUEST(state, request) {
        state.currentRequest = request;
    },
    SET_STATS(state, stats) {
        state.stats = stats;
    },
    UPDATE_REQUEST_STATUS(state, { id, status, admin_notes }) {
        const request = state.requests.find((r) => r.id === id);
        if (request) {
            request.status = status;
            if (admin_notes)
                request.admin_notes = admin_notes;
        }
        if (state.currentRequest && state.currentRequest.id === id) {
            state.currentRequest.status = status;
            if (admin_notes)
                state.currentRequest.admin_notes = admin_notes;
        }
    },
};
const actions = {
    async createRequest({ commit }, requestData) {
        try {
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            return await rmaService.createRequest(requestData);
        }
        catch (error) {
            commit('SET_ERROR', error.message || 'Failed to create request');
            throw error;
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
    async fetchRequests({ commit }, params = {}) {
        try {
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            const response = await rmaService.getRequests(params);
            commit('SET_REQUESTS', {
                requests: response.data.data,
                pagination: response.data.pagination,
            });
            return response;
        }
        catch (error) {
            commit('SET_ERROR', error.message || 'Failed to fetch requests');
            throw error;
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
    async fetchRequest({ commit }, id) {
        try {
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            const response = await rmaService.getRequest(id);
            console.log('RMA Request response:', response.data);
            commit('SET_CURRENT_REQUEST', response.data.data);
            return response;
        }
        catch (error) {
            commit('SET_ERROR', error.message || 'Failed to fetch request');
            throw error;
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
    async updateRequestStatus({ commit }, { id, status, admin_notes, priority, disposition, fault_description, erp_type, }) {
        try {
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            const response = await rmaService.updateRequestStatus(id, {
                status,
                admin_notes,
                priority,
                disposition,
                fault_description,
                erp_type,
            });
            commit('UPDATE_REQUEST_STATUS', { id, status, admin_notes, priority });
            return response.data;
        }
        catch (error) {
            commit('SET_ERROR', error.message || 'Failed to update request status');
            throw error;
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
    async getRequestStatus({ commit }, rmaNumber) {
        try {
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            return await rmaService.getRequestStatus(rmaNumber);
        }
        catch (error) {
            commit('SET_ERROR', error.message || 'Failed to get request status');
            throw error;
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
    async fetchStats({ commit }) {
        try {
            const response = await rmaService.getStats();
            console.log('RMA Stats response:', response.data);
            commit('SET_STATS', response.data);
            return response;
        }
        catch (error) {
            commit('SET_ERROR', error.message || 'Failed to fetch stats');
            throw error;
        }
    },
};
const getters = {
    requests: (state) => state.requests,
    currentRequest: (state) => state.currentRequest,
    stats: (state) => state.stats,
    loading: (state) => state.loading,
    error: (state) => state.error,
    pagination: (state) => state.pagination,
};
const rma = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
export default rma;
